import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { NamedLink } from '../../components';
import { useConfiguration } from '../../context/configurationContext';
import { categoryNameForSEO, categoryOptionsFromConfig } from '../../util/categorySEO';

import css from './LandingPage.module.css';

const SectionCategoryLinks = () => {
  const config = useConfiguration();
  const intl = useIntl();
  const categories = categoryOptionsFromConfig(config);

  return (
    <section className={css.categorySection} aria-labelledby="browse-by-property-type">
      <h2 id="browse-by-property-type">
        <FormattedMessage id="LandingPage.categoryHeading" />
      </h2>
      <nav
        className={css.categoryLinks}
        aria-label={intl.formatMessage({ id: 'LandingPage.categoryNavLabel' })}
      >
        {categories.map(category => (
          <NamedLink
            key={category.option}
            name="CategoryPage"
            params={{ category: category.option }}
            className={css.categoryLink}
          >
            <FormattedMessage
              id="LandingPage.categoryLink"
              values={{ category: categoryNameForSEO(category.option, category.label) }}
            />
          </NamedLink>
        ))}
      </nav>
    </section>
  );
};

export default SectionCategoryLinks;
